import script from "./lcDailogPQ.vue?vue&type=script&setup=true&name=LDialog&lang=js"
export * from "./lcDailogPQ.vue?vue&type=script&setup=true&name=LDialog&lang=js"

import "./lcDailogPQ.vue?vue&type=style&index=0&id=aa9ec14a&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa9ec14a"]])

export default __exports__